var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"room-back",attrs:{"src":require("../../../../assets/image/live/back.png")},on:{"click":_vm.back}})
}
var staticRenderFns = []

export { render, staticRenderFns }